import { useId } from 'react';
import { Box, InputLabel, Typography } from '@mui/material';

import BaseFieldContainer from '../common/baseFieldContainer';
import { buildInputLabelSx } from '../fCheckboxGroup/utils/general';
import { mergeSx } from '../utils/general';
import {
  F_OUTLINED_VALUE_CONTENT_SX,
  F_OUTLINED_VALUE_FIELD_SX,
  F_OUTLINED_VALUE_TEXT_SX,
} from './constants';

import type { FOutlinedValueProps } from './types';

function FOutlinedValue({
  label,
  value,
  children,
  required,
  showRequiredIndicator,
  disabled,
  error = false,
  fullWidth = true,
  contentSx,
  inputLabelProps,
  sx,
  ...rest
}: FOutlinedValueProps) {
  const generatedId = useId();
  const { sx: inputLabelSx, ...restInputLabelProps } = inputLabelProps ?? {};
  const labelId = `foutlined-value-label-${generatedId}`;

  return (
    <BaseFieldContainer
      required={required}
      showRequiredIndicator={showRequiredIndicator}
      disabled={disabled}
      error={error}
      fullWidth={fullWidth}
      alwaysRenderContainer
    >
      <InputLabel
        {...restInputLabelProps}
        id={labelId}
        error={error}
        disabled={disabled}
        required={(showRequiredIndicator ?? (Boolean(required) && !disabled)) ? false : required}
        shrink
        sx={buildInputLabelSx(inputLabelSx)}
      >
        {label}
      </InputLabel>
      <Box
        aria-labelledby={labelId}
        sx={mergeSx(F_OUTLINED_VALUE_FIELD_SX, sx)}
        {...rest}
      >
        <Box sx={mergeSx(F_OUTLINED_VALUE_CONTENT_SX, contentSx)}>
          {children ?? <Typography sx={F_OUTLINED_VALUE_TEXT_SX}>{value}</Typography>}
        </Box>
      </Box>
    </BaseFieldContainer>
  );
}

export default FOutlinedValue;
